<template>
    <div class="box" >
     <h2>我的工作台</h2>
     <div class="hr"></div>
     <div class="contaner-top">
         <Row>
             <Col span="3" class="left-col"><img src="../assets/avatar.png" alt=""></Col>
             <Col span="21">
             <p class="right-top"><span>早上好,{{UserInfo.Realname}}！</span></p>
              <div class="hr"></div>
             <!-- <Row class="right-bottom">
                 <Col span="4">
                 <p>账户总额</p>
                 <span>{{UserInfo.Account_Total}}</span>
                 </Col>
                  <Col span="2">
                =
                 </Col>
                  <Col span="4">
                 <p>可用金额</p>
                 <span>{{Detail.ableAmount}}</span>
                 </Col>
                  <Col span="2">
                 +
                 </Col>
                  <Col span="4">
                 <p>项目冻结</p>
                 <span>{{Detail.Unpaid}}</span>
                 </Col>
                  <Col span="4" class="last_col">
                    <Button type="info">提现</Button>
                    <a href="javascript:;">收支明细</a>
                    </Col>
                </Row> -->
             </Col>
         </Row>
     </div>
     <ul class="contaner-center">
         <li>
             <p>{{Detail.BiddingNum}}</p>
             <span>竞标中</span>
           </li>
            <li>
             <p>{{Detail.UnderDevelopmentNum}}</p>
             <span>开发中项目</span>
           </li>
              <li>
             <p>{{Detail.OverTimeNum}}</p>
             <span>超时项目</span>
           </li>
            <li>
             <p>{{Detail.CompleteProjectNum}}</p>
             <span>完成项目</span>
           </li>
     </ul>
     <h2 class="title2">待处理的项目动态({{pendingList.length}})</h2>
     <div class="hr"></div>
    <Table class="table" :columns="pendingListColumns" :data="pendingList"></Table>
    <h2 class="title2">优秀供应商推荐 <a href="javascript:;" @click="goToMemberList">查看更多</a></h2>
    <div class="hr"></div>
    <Table class="table" :columns="recommendListColumns" :data="recommendList"></Table>
    <Modal  v-model="showDetail" :closable="false" width='765'>
        <div slot="header" class="header-modal">
            <img src="../assets/detail.png" alt="">
            <span>用户详情</span>
            <img class="close" @click="showDetail=false" src="../assets/close.png" alt="">
        </div>
        <div class="content-modal table-c">
            <Tabs value="name1">
                <TabPane label="基本信息" name="name1">
                    <table border="0" cellspacing="0" cellpadding="0">
                          <tr>
                               <td class="label" width="100">用户ID</td>
                                <td width="140">{{UserDetail.ID}}</td>
                                <td  class="label"  width="100">联系人</td>
                                <td width="140">{{UserDetail.Realname}}</td>
                                 <td  class="label"  width="100">手机号</td>
                                <td width="140">{{UserDetail.TelCode}} {{UserDetail.Tel}}</td>
                          </tr>
                          <tr>
                               <td class="label" width="100">邮箱</td>
                                <td width="140">{{UserDetail.Email}}</td>
                                <td  class="label"  width="100">QQ</td>
                                <td width="140">{{UserDetail.QQ}}</td>
                                <td  class="label"  width="100">微信</td>
                                <td width="140">{{UserDetail.WX}}</td>
                          </tr>
                          <tr>
                               <td class="label" width="100">认证状态</td>
                                <td width="140">
                                    <span v-if="UserDetail.Status==0">资料未完善</span>
                                    <span v-if="UserDetail.Status==1">未认证</span>
                                    <span v-if="UserDetail.Status==2">待审核</span>
                                    <span v-if="UserDetail.Status==3">审核通过</span>
                                </td>
                                <td  class="label"  width="100">供应商评级</td>
                                <td  width="140">{{UserDetail.SupplierRate}}</td>
                        </tr>
                         <tr>
                                <td  class="label" width="100">擅长项目</td>
                                <td  width="140" colspan="2"><span v-if="UserDetail.Fields" v-for="(ite,index) in UserDetail.Fields">{{ite}} ,</span></td>
                                <td  class="label"  width="100">累计完成金额</td>
                                <td  width="140" colspan="2">{{UserDetail.Amount_Total}}</td>
                        </tr>
                         <tr>
                               <td class="label" width="100">技能标签</td>
                                <td width="140" colspan="5">{{UserDetail.Skill}}</td>
                        </tr>
                         <tr>
                               <td class="label" width="100">工作地</td>
                                <td width="140" colspan="5">{{UserDetail.place}}</td>
                        </tr>
                         <tr>
                               <td class="label" width="100">支付宝</td>
                                <td width="140" colspan="5">{{UserDetail.Alipay}}</td>
                        </tr>
                         <tr>
                               <td class="label" width="100">银行卡号</td>
                                <td width="140" colspan="5" ><span v-if="UserDetail.Bank">{{UserDetail.Bank.Account}}</span></td>
                        </tr>
                          <tr>
                               <td class="label" width="100">户名</td>
                                <td width="140" colspan="5" ><span v-if="UserDetail.Bank">{{UserDetail.Bank.Name}}</span></td>
                        </tr>
                          <tr>
                               <td class="label" width="100">开户行</td>
                                <td width="140" colspan="5" ><span v-if="UserDetail.Bank">{{UserDetail.Bank.Username}}</span></td>
                        </tr>
                         <tr>
                               <td class="label" width="100">备注</td>
                                <td width="140" colspan="5">{{UserDetail.Comment}}</td>
                        </tr>
                    </table>
                </TabPane>
                <TabPane label="用户认证" name="name2">
                     <table border="0" cellspacing="0" cellpadding="0">
                        <tr>
                               <td class="label" width="100">供应商类型</td>
                                <td width="280" colspan="2"><span v-if="UserDetail.VerifyType==1">个人</span><span v-if="UserDetail.VerifyType==2">工作室 / 公司</span></td>
                                <td class="label"  width="100">规模</td>
                                <td width="280" colspan="2">{{UserDetail.Scale}}</td>
                        </tr>
                        <tr>
                               <td class="label" width="100">有效证件</td>
                                <td width="140" colspan="5"  height="119">
                                    <div v-if="UserDetail.Certificate">
                                        <img style=" width: 154px; height: 94px;cursor:pointer" @click="checkImg(item,index)" v-for="(item,index) in UserDetail.Certificate"  :src="imgUrl+item" alt="">
                                    </div>
                                </td>
                        </tr>
                        <tr>
                               <td class="label" width="100">企业名称</td>
                                <td width="140" colspan="5">
                                    <div>
                                      {{UserDetail.CompanyName}} 
                                    </div>
                                </td>
                        </tr>
                          <tr>
                               <td class="label" width="100">企业住所</td>
                                <td width="140" colspan="5">
                                    <div>
                                      {{UserDetail.CompanyAddress}} 
                                    </div>
                                </td>
                        </tr>
                          <tr>
                               <td class="label" width="100">企业法人</td>
                                <td width="140" colspan="5">
                                    <div>
                                      {{UserDetail.CompanyLeader}} 
                                    </div>
                                </td>
                        </tr>
                          <tr>
                               <td class="label" width="100">社会统一信用代码</td>
                                <td width="140" colspan="5">
                                    <div>
                                      {{UserDetail.CompanyCode}} 
                                    </div>
                                </td>
                        </tr>
                          <tr>
                               <td class="label" width="100">企业成立时间</td>
                                <td width="140" colspan="5">
                                    <div>
                                      {{UserDetail.CompanyDate}} 
                                    </div>
                                </td>
                        </tr>
                           <tr>
                               <td class="label" width="100">通讯地址</td>
                                <td width="140" colspan="5">
                                    <div>
                                      {{UserDetail.TelAddress}} {{UserDetail.DetailedAddress}}
                                    </div>
                                </td>
                        </tr>
                          <tr>
                               <td class="label" width="100">联系人</td>
                                <td width="140" colspan="5">
                                    <div>
                                      {{UserDetail.ContactName}} 
                                    </div>
                                </td>
                        </tr>
                          <tr>
                               <td class="label" width="100">联系方式</td>
                                <td width="140" colspan="5">
                                    <div>
                                      {{UserDetail.ContactWay}} 
                                    </div>
                                </td>
                        </tr>
                        <tr>
                               <td class="label" width="100">项目经历</td>
                                <td width="140" colspan="5" height="108" style="text-align:left;vertical-align: initial;">{{UserDetail.ItemProcess}}</td>
                        </tr>
                        <tr>
                               <td class="label" width="100">作品展示</td>
                                <td width="140" colspan="5">
                                    <div v-if="UserDetail.FilePath" style="cursor:pointer;text-align:left;" >
                                        <p @click="download(item)" v-for="(item,index) in FilePath">{{item.Name}}  </p>
                                    </div>
                                </td>
                        </tr>
                    </table>
                </TabPane>
            </Tabs>
            </div>
           <div slot="footer">
               <Button type="info" @click="showDetail=false" >关闭</Button>
           </div>
       </Modal>
    </div>
</template>
<script>
export default {
    data(){
        return{
            FilePath:[],//文件路径
            imgUrl:this.$baseImg,//图片路径
            Detail:{},//页面详情
            showDetail:false,//显示供应商详情
            UserDetail: {FinishProjectNum:[]},//供应商详情
            pendingListColumns: [
                    {
                        title: '项目名称',
                        key: 'name',
                        render:(h,params)=>{
                            if (params.row.TypeID == 2) {
                                let text = '私';
                                return h('div', [
                                    h('span', {
                                        style:{
                                            backgroundColor: '#ff4d4d',
                                            color: '#fff',
                                            padding: '5px',
                                            borderRadius: '5px',
                                            marginRight: '5px',
                                            fontSize: '12px'
                                        }
                                    }, text),
                                    h('span', {
                                        style:{
                                            color:'#0198CD',
                                            fontSize:"13px"
                                        }
                                    }, params.row.Name),
                                ]);
                            } else {
                                return h('div', [
                                    h('span', {
                                        style:{
                                            color:'#0198CD',
                                            fontSize:"13px"
                                        }
                                    }, params.row.Name),
                                ]);
                            }
                        }
                    },
                    {
                        title: '项目状态',
                        key: 'status',
                        width:200,
                        align:'center',
                         render:(h,params)=>{
                             var text="竞标中"
                             if(params.row.Status==2){
                                text="开发中"
                             }
                         return h('div', [
                                h('span', {
                                    style:{
                                        color:'#0198CD',
                                        fontSize:"13px"
                                    }
                                }, text),
                            ]);
                        }
                    },
                    {
                        title: '发布时间',
                        key: 'AddTime',
                        width:200,
                        align:'center'
                    },
                    {
                        title: '备注',
                        key: 'Comment',
                        align:'center',
                        width:300
                    },
                    {
                        title: '操作',
                        key: 'address',
                        align:'center',
                        width:200,
                        render:(h,params)=>{
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small'
                                    },
                                    on:{
                                        "click":()=>{
                                            this.goToProjectDetail(params.row);
                                        }
                                    }
                                }, '管理项目'),
                              ]);
                        }
                    }
                ],
                 recommendListColumns: [
                    {
                        title: '供应商',
                        key: 'Realname',
                        align:'center',
                        render:(h,params)=>{
                         return h('div', [
                                h('span', {
                                    style:{
                                        color:'#0198CD',
                                        fontSize:"13px"
                                    }
                                }, params.row.Realname),
                            ]);
                        }
                    },
                    {
                        title: '规模',
                        key: 'Scale',
                        align:'center'
                    },
                        {
                        title: '承接项目',
                        key: 'projectNum',
                        align:'center'
                    },
                    {
                        title: '级别',
                        key: 'date',
                        align:'center',
                        render:(h,params)=>{
                            var arr=[]
                            for(var i=0;i<params.row.LV;i++){
                                      arr.push( h('img', {
                                        style: {
                                            width: "13px",
                                            verticalAlign: "middle"
                                        },
                                        attrs: {
                                            src: '../../static/img/zhan.png'
                                        }
                                    },))
                            }
                            return h('div',arr);

                        }
                    },
                     {
                        title: '总收入',
                        key: 'Amount_Total',
                        align:'center'
                    },
                     {
                        title: '操作',
                        align:'center',
                        render:(h,params)=>{
                              return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small'
                                    },
                                    on:{
                                        "click":()=>{
                                            this.catMemberDetail(params.row);
                                        }
                                    }
                                }, '查看详情'),
                            ]);
                        }
                    }
                ],
                pendingList: [],//待处理列表
                recommendList: [],//推荐列表
                UserInfo:{},//用户信息

        }
    },
    mounted(){
        if(this.$getLS('AdminInfo')){
            this.UserInfo=JSON.parse(this.$getLS('AdminInfo'));
        }
        // //获取首页数据
        // this.$post('api/manage.ProjectManage/getIndexData').then(res=>{
        //     if (res.code == 1) {
        //         this.Detail = res.data;
        //     }
        // })
        // //待处理项目列表
        // this.$post('api/manage.ProjectManage/getPendingProjectList').then(res=>{
        //     if (res.code == 1) {
        //         this.pendingList = res.data;
        //     }
        // });
        //推荐供应商列表
        // this.$post('api/manage.ProjectManage/getRecommendMemberList').then(res=>{
        //     if (res.code == 1) {
        //         let recommendList = res.data;
        //         for (let i = 0; i < recommendList.length; i++) {
        //             recommendList[i]['Fields'] = JSON.parse(recommendList[i]['Fields']);
        //             recommendList[i]['Address'] = JSON.parse(recommendList[i]['Address']);
        //             recommendList[i]['TelAddress'] = JSON.parse(recommendList[i]['TelAddress']);
        //             recommendList[i]['Certificate'] = JSON.parse(recommendList[i]['Certificate']);
        //             recommendList[i]['FilePath'] = JSON.parse(recommendList[i]['FilePath']);
        //             recommendList[i]['Bank'] = JSON.parse(recommendList[i]['Bank']);
        //             recommendList[i]['TelAddress']=  this.$pcaa[86][recommendList[i].TelAddress.Province]+this.$pcaa[recommendList[i].TelAddress.Province][recommendList[i].TelAddress.City]+this.$pcaa[recommendList[i].TelAddress.City][recommendList[i].TelAddress.Area]
        //         }
        //         this.recommendList = recommendList;
        //     }
        // });
    },
    methods:{
        //前往管理页面
        goToProjectDetail(row) {
            if(row.Status==1){
                this.$router.push({path:'index/BiddingProjectDetail',query:{ID:row.ID}})
            }else{
                this.$router.push({path:'index/ProjectDetailBidding',query:{ID:row.ID}})
            }
        },
        //查看用户详情
        catMemberDetail(row) {
            this.showDetail = true;
            this.UserDetail = row;
            this.UserDetail.Fields = JSON.parse(row.FIelds);
        },
        //前往供应商列表页
        goToMemberList() {
            this.$router.push({path:'index/Supplier'});
        }
    }
}
</script>
<style lang="less" scoped>
.box{
    >h2{
       color: #435365;
       font-size: 18px;
       font-weight: normal;
       padding-bottom: 10px;
    }
    .title2{
        margin-top: 30px;
        >a{
            margin-top: 5px;
            float:right;color:#0097CA;font-size:13px;
            text-decoration: underline;
        }
    }
    .contaner-top{
        background-color: #fff;
        padding:20px 0px;
        margin-top: 30px;
        box-shadow: 0px 3px 5px #D9DDE3;
        border-radius: 5px;
        .left-col{
            text-align: center;
            img{
                width: 50%;
            }
        }
        .right-top{
            color: #1789C8;
            font-size: 16px;
            margin-top: 15px;
            margin-bottom: 15px;
            display: flex;
            img{
                width:13px ;
                height: 13px;
                margin-left: 3px;
                margin-top: 3px;
            }
            button{
                margin-left: 10px;
            }

        }
        .right-bottom{
            margin-top:20px;
            .ivu-col{
                // text-align: center;
                >p{
                    color: #6A6A6A;
                    margin-bottom: 10px;
                }
                >span{
                    color: #FF8606;
                    font-size: 20px;
                }
            }
            .last_col{
                margin-top: 29px;
                display: flex;
                a{
                    color: #0197CA;
                    font-size: 13px;
                    margin-top: 15px;
                    margin-left: 10px;
                    text-decoration: underline;
                }
            }
        }
    }
    .contaner-center{
        background-color: #fff;
        padding:20px 15px;
        margin-top: 30px;
        box-shadow: 0px 3px 5px #D9DDE3;
        border-radius: 5px;
        display: flex;
        li{
            flex:1;
            border-left:2px solid #FF8000;
            padding-left:15px;
            p{
                font-size: 30px;
                color: #303944;
                margin-bottom: 10px;
            }
            span{
                color: #88929E;
            }
        }
    }
    .table{
        margin-top: 20px;
        box-shadow: 0px 3px 5px #D9DDE3;
    }
}
  .table-c{
 table{
     border-right:1px solid #CAF2FF;border-bottom:1px solid #CAF2FF;
  td{
border-left:1px solid #CAF2FF;
padding:10px;
  text-align: center;
  border-top:1px solid #CAF2FF;
  font-size:12px;}
  .label{
      background-color: #F0FCFF;
      color: #0092C1;
  }
 } 
}
 .header-modal{
        padding:10px 15px;
        color: #fff;
        background-color: #01AAE3;
        font-size: 22px;
        display: flex;
        position: relative;
        span{
            margin-left: 20px;
            margin-top: 3px;
        }
        .close{
            width: 22px;
            height: 22px;
            position: absolute;
            right:14px;
            cursor: pointer;
            top:14px;
        }
    }
.content-modal{
    padding:20px;

}
.input-text{
    width: 100%;
    border-radius: 5px;
    border: 1px solid #eee;
    height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/Overview.vue